module.exports = __webpack_public_path__ + "img/assortment-info.e29c7658.svg";